import { generateQueryKey } from 'query';

export * from './useGenders';
export * from './useProfessions';
export * from './useEducationsLevel';
export * from './useInterests';

export const getEducationLevelsQueryKey = () => generateQueryKey(['educationLevels']);

export const getProfessionsQueryKey = () => generateQueryKey(['professions']);

export const getGendersQueryKey = () => generateQueryKey(['genders']);

export const getInterestsQueryKey = () => generateQueryKey(['interests']);
